import { useLayoutEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Transition } from 'react-transition-group'

import RunnerGoalIcon from '@/components/Runner/RunnerGoalIcon'
import RunnerShoppingCounter from '@/components/Runner/RunnerShoppingCounter'
import RunnerShoppingFixedCounter from '@/components/Runner/RunnerShoppingFixedCounter'
import { useRunnerState } from '@/composables/useRunnerState'
import { useRunnerUITransition } from '@/composables/useRunnerUITransition'

const RunnerGoalShopping = () => {
  const { persona, scenario, gameState, shoppingState } = useRunnerState()
  const segment = gameState.currentSegment

  const nodeRef = useRef<HTMLDivElement>(null)
  const { t } = useTranslation()
  const [isVisible, setIsVisible] = useState(false)

  useLayoutEffect(() => {
    if (persona === 'francesca' && scenario === 1) {
      const shoppingSegments = [
        'shopping',
        'shopping_bis',
        'shopping_balance',
        'audio_receipt',
        'popin2',
        'audio_balance',
      ]
      if (shoppingSegments.includes(segment)) {
        setIsVisible(true)
      }
    } else {
      setIsVisible(false)
    }
  }, [persona, scenario, segment])

  const { onEnter, onExit, timeout } = useRunnerUITransition(nodeRef, { from: 'top' })
  const completion = gameState.completion
  const currentBlock = completion ? gameState.completion.blocks[gameState.completion.currentBlock] : null
  const isFreezing = shoppingState?.freezeActive
  let goal = currentBlock && currentBlock.goal[0] ? currentBlock.goal[0] : 'receipt'
  if (isFreezing) goal = 'brain_freeze'

  return (
    <Transition
      in={isVisible}
      nodeRef={nodeRef}
      mountOnEnter
      unmountOnExit
      onEnter={onEnter}
      onExit={onExit}
      timeout={timeout}
    >
      <div ref={nodeRef} className='RunnerGoalShopping RunnerGoal absolute top-0'>
        <div className='flex mt-12 bg-secondary rounded-24 border-4 border-mid-blue'>
          <RunnerShoppingFixedCounter value={shoppingState?.walletValue || 0} label={t('misc.wallet')} />
          {goal && <RunnerGoalIcon image={goal} searched={false} ordered={false} index={0} collected={false} />}
          <RunnerShoppingCounter fixed={false} label={t('misc.cart')} />
        </div>
      </div>
    </Transition>
  )
}

export default RunnerGoalShopping
